<div class="loaders-error" [ngClass]="{'-inverted': inverted}">
    <svg class="loaders-error__svg" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
        <line class="loaders-error__path path line" x1="34.4" y1="37.9" x2="95.8" y2="92.3" />
        <line class="loaders-error__path path line" x1="95.8" y1="38" x2="34.4" y2="92.2" />
    </svg>
</div>